import { createContext, PropsWithChildren } from "react";
import { useListAccount } from "../Account/LinkAccount/utils";
import { LinkAccountType } from "../Account/LinkAccount/types";

export const LinkAccountContext = createContext<{
    data: LinkAccountType[],
    isLoading: boolean
    refetch: () => void
}>({
    data: [],
    isLoading: false,
    refetch: () => {}
});

export function LinkAccountProvider(params: PropsWithChildren){
   const { data, isLoading, refetch } = useListAccount()

    return (
            <LinkAccountContext.Provider value={{ data, isLoading, refetch }}>
                {params.children}
            </LinkAccountContext.Provider>
    )
}